import {Icon, Style} from "ol/style";
import urgentMarkerUrl from "../../../../assets/icons/urgent-map-marker.svg";

export const urgentIconStyle = new Style({
  image: new Icon({
    src: urgentMarkerUrl,
    anchor: [0.5, 0.5],
    scale: 0.2
  }),
  zIndex: 10
});
